import * as Scrivito from "scrivito";
import parse from "html-react-parser";

export const EventPageLocation = Scrivito.connect(({ page }) => {
  const locationName = page.get("locationName");
  const locationRoom = page.get("locationRoom");
  const locationStreet = page.get("locationStreet");
  const locationPostalCode = page.get("locationPostalCode");
  const locationCity = page.get("locationCity");
  const locationCountry = page.get("locationCountry");

  const hasNameOrRoom = !!(locationName || locationRoom);
  const hasAddress = !!(
    locationStreet ||
    locationPostalCode ||
    locationCity ||
    locationCountry
  );

  return (
    <div className="text-gray my-3">
      <div className="pb-2">
        <i className="las la-map-marker me-1" />
        {locationName && (
          <span className="event-location-name">{parse(locationName)}</span>
        )}
        {locationName && locationRoom && <span> | </span>}
        <Scrivito.ContentTag
          tag="span"
          content={page}
          attribute="locationRoom"
        />
        {hasNameOrRoom && hasAddress && <span> | </span>}
        <Scrivito.ContentTag
          tag="span"
          content={page}
          attribute="locationStreet"
        />
        {locationStreet &&
          (locationPostalCode || locationCity || locationCountry) && (
            <span>, </span>
          )}
        <Scrivito.ContentTag
          tag="span"
          content={page}
          attribute="locationPostalCode"
        />
        {locationPostalCode && (locationCity || locationCountry) && " "}
        <Scrivito.ContentTag
          tag="span"
          content={page}
          attribute="locationCity"
        />
        {locationCity && locationCountry && " "}
        <Scrivito.ContentTag
          tag="span"
          content={page}
          attribute="locationCountry"
        />
      </div>
    </div>
  );
});
